import { render, staticRenderFns } from "./AllRecommendedCourses.vue?vue&type=template&id=5ede2f57&scoped=true"
import script from "./AllRecommendedCourses.vue?vue&type=script&lang=js"
export * from "./AllRecommendedCourses.vue?vue&type=script&lang=js"
import style0 from "./AllRecommendedCourses.vue?vue&type=style&index=0&id=5ede2f57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede2f57",
  null
  
)

export default component.exports